import { render, staticRenderFns } from "./KonsulAntarPoliDetail.vue?vue&type=template&id=0bd895ee"
import script from "./KonsulAntarPoliDetail.vue?vue&type=script&lang=js"
export * from "./KonsulAntarPoliDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bd895ee')) {
      api.createRecord('0bd895ee', component.options)
    } else {
      api.reload('0bd895ee', component.options)
    }
    module.hot.accept("./KonsulAntarPoliDetail.vue?vue&type=template&id=0bd895ee", function () {
      api.rerender('0bd895ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/KonsulAntarPoliDetail.vue"
export default component.exports